import React from 'react';
export function FlagStripe({
  thick = false
}: {
  thick?: boolean;
}) {
  const h = thick ? 'h-2' : 'h-1';
  const colors = ['bg-crimson', 'bg-cobalt', 'bg-emerald', 'bg-saffron', 'bg-ivory'];
  return <div className="w-full flex flex-col" role="separator" aria-hidden="true" data-id="element-145">
      {colors.map((color, i) => <div key={i} className={`${color} ${h} w-full`} data-id="element-146" />)}
    </div>;
}